import { Avatar, AvatarFallback, AvatarImage, cn } from "@tellescope/ui";
import { useSecureFileUrl, type TellescopeModelFromName } from "@tellescope/tanstack-query";
import { formatInitials } from "@tellescope/utils";

interface MessageSenderAvatarProps {
  user: TellescopeModelFromName<"users">;
  className?: string;
}

export const MessageSenderAvatar = ({ user, className }: MessageSenderAvatarProps) => {
  const avatarUrl = useSecureFileUrl(user.avatar);

  return (
    <Avatar className={cn("h-8 w-8 flex-shrink-0", className)}>
      <AvatarImage src={avatarUrl} />
      <AvatarFallback useStaticBackground id={user.id}>
        {formatInitials(user)}
      </AvatarFallback>
    </Avatar>
  );
};
